export const facturacion = {
    text1: "Forma de pagamento",
    text2: "Cartão de crédito",
    text3: "Nenhuma forma de pagamento cadastrada",
    text4: "Edite sua forma de pagamento",
    text5: "Adicionar forma de pagamento",
    text6: "Adicionar uma forma de pagamento",
    text7: "Atualizar uma forma de pagamento",
    text8: "Cadastre ou atualize a forma de pagamento onde as cobranças mensais serão feitas.",
    text9: "Número do cartão:",
    text10: "Val.",
    text11: "CVC",
    text12: "Salvar cartão",
    text13: "Número inválido",
    text14: "Inválida",
    text15: "CVC inválido.",
    text16: "Algo deu errado",
    text17: "Consumo",
    text18: "Faturas emitidas",
    text19: "De - Até",
    text20: "ID",
    text21: "Valor",
    text22: "Entidade emissora da fatura",
    text23: "BIG NERDS COMPANY L.L.C.",
    text24: "Data de emissão",
    text25: "Situação",
    text26: "Baixar fatura",
    text27: "Gerando fatura ...",
    text28: "Quase pronto, aguarde...",
    text29: "Carregando ...",
    text30: "Desculpe, não foi possível gerar a fatura",
    text31: "Tem certeza de que deseja excluir a forma de pagamento?",
    text32: "Você perderá seus dados salvos",
    text33: "Excluir método",
    text34: "Cancelar",

    // Corrections
    p1: "Assinatura",
    p2: "Sua assinatura",
    p3: "FREE",
    p4: "CUSTOM",
    p5: "Você não tem uma assinatura ativa. Vamos resolver isso!",
    p6: "Expira:",
    p7: "Escolha um plano",
    p8: "Fazer upgrade",
    p9: "Número de propriedades",
    p10: "Por propriedade",
    p11: "Gerenciar assinatura",
    p12: "Configurações de pagamento",
    p13: "Expira:",
    p14: "Editar",
    p15: "Renovação automática",
    p16: "Ativada",
    p17: "O próximo pagamento está agendado para",
    p18: "Faturas e recibos",
    p19: "CUSTOM",
    p20: "Ver fatura",
    p21: "Baixar fatura",
    p22: "por",

    p23: "Mensal",
    p24: "Anual",
    p25: "Estamos te dando 2 meses de presente.",
    p26: "Tipo de assinatura",


    p27: "Apartamento turístico",
    p28: "Hotel - Hostel",
    p29: "Camping",
    p30: "Villa",


    p31: `A "<strong>Propriedade</strong>" baseia-se em casas ou apartamentos individuais. Para "<strong>Aparthotel</strong>", cada apartamento conta como uma única propriedade`,
    p32: `Conta como
    <strong>Quartos</strong> no caso de hotéis, como camas no caso de hostels,
    e como <strong>pessoas </strong> no caso de camping.

    <br />
    <strong>Por exemplo:</strong> Um hostel com 4 quartos e 20 camas contará como
    20 unidades de acomodação`,

    p33: `PREMIUM`,
    p34: `mês`,
    p35: `quarto`,
    p36: `apartamento`,
    p37: `Detalhes do plano`,
    p38: `Check-in presencial via QR`,
    p39: `Check-in por link enviado antecipadamente`,
    p40: `Mensagem de boas-vindas por e-mail`,
    p41: `Assinatura biométrica de políticas`,
    p42: `Scanner de documento e passaporte`,
    p43: `Armazenamento em nuvem ilimitado`,
    p44: `Loja de vendas cruzadas`,
    p45: `Envio automático de relatórios às autoridades`,
    p46: `Sincronização de reservas PSM`,
    p47: `Atualizar assinatura`,
    p48: `Continuar`,
    p49: `por`,

    p50: `Selecione serviços adicionais para o seu plano`,
    p51: `Recomendado`,
    p52: `WhatsApp`,
    p53: `Convidamos seus hóspedes a fazer o check-in pelo WhatsApp, agendado antes de chegarem à sua acomodação.`,
    p54: `apartamento`,
    p55: `villa`,
    p56: `vaga`,
    p57: `quarto`,
    p58: `Diferença ao usar o WhatsApp`,
    p59: `Usando o nosso WhatsApp`,
    p60: `Ao usar o nosso serviço de WhatsApp, o nome do remetente das mensagens enviadas aos seus hóspedes será WACheckin. Nós cuidamos da gestão das mensagens para garantir uma comunicação eficaz com os seus hóspedes.`,
    p61: `Se você usar o nosso serviço com o seu próprio número de WhatsApp, o nome do remetente será o nome do seu WhatsApp, e você pode ter o seu selo de verificação. O custo de envio estará sujeito ao consumo do seu WhatsApp Business com a Meta.`,
    p62: `Usando o seu WhatsApp Business`,
    p63: `Avaliações`,
    p64: `Aproveite esta oportunidade para melhorar a experiência dos seus hóspedes e conquistar mais avaliações positivas!`,
    p65: `Benefícios`,
    p66: `No checkout, enviaremos aos seus hóspedes uma pesquisa de avaliação pelo WhatsApp, aumentando significativamente a reputação online da sua propriedade. Nosso serviço foi feito para aumentar suas avaliações positivas.`,
    p67: `Acesso remoto`,
    p68: `Enviamos aos seus hóspedes uma chave virtual para acesso autônomo à propriedade.`,
    p69: `Benefícios`,
    p70: `Seus hóspedes receberão as chaves de acesso ao quarto de forma segura e prática assim que concluírem o check-in, proporcionando uma experiência sem complicações e melhorando a eficiência da gestão de acessos.`,
    p71: `Verificação de identidade`,
    p72: `Verificamos a identidade dos seus hóspedes usando nosso software de comparação biométrica.`,
    p73: `Benefícios`,
    p74: `Verificamos a identidade dos seus hóspedes usando nosso software de comparação biométrica, garantindo que a documentação corresponda à pessoa que acessa a sua acomodação.`,
    p75: `Assine agora`,
    p76: `Armazenamento em nuvem ilimitado`,
    p77: `Personalizado`,
    p78: `Consulte nossa equipe de vendas`,
    p79: `WhatsApp`,
    p80: `Verificação de identidade`,
    p81: `Avaliações (notas do check-in)`,
    p82: `Conexão com API para fechaduras inteligentes`,
    p83: `Cobrança no cartão (para depósitos, serviços, etc.)`,
    p84: `Fale com vendas`,
    p85: ``,
    p86: ``,
    p87: ``,
    p88: ``,
    p89: ``,






};
